const styles = theme => ({
  root: theme.mixins.gutters({

  }),
  centred: {
    width: '100%',
    maxWidth: '1320px',
    alignSelf: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: theme.spacing.unit,
  },
  toolbar: {
    minWidth: 0,
  },
  flex: {
    flex: '1 1 16px',
    minWidth: 16
  },
  logo: {
    flex: '0 0 auto',
    marginRight: 10
  },
  functionBarTitle: {
    color: theme.palette.primary.contrastText,
    fontSize: '0.875rem',
    fontWeight: '300',
    marginRight: 10,
    lineHeight: 1
  },
  currentTitle: {
    flex: '1 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  functionBar: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText
  },
  custTitle: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText
  },
  custName: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    pointerEvents: 'none'
  }
})

export default styles
